import { apiGet, apiPost } from './client';

export interface StepStatus {
  id: string;
  label: string;
  description: string;
  status: 'not_started' | 'in_progress' | 'completed';
  evidence_count: number;
  blocking_reason: string | null;
  cta_target: string;
  recommended_next: string | null;
  order: number;
}

export interface OnboardingStatus {
  steps: StepStatus[];
  completed_count: number;
  total_count: number;
}

export interface OnboardingResponse {
  data: OnboardingStatus;
  dismissed: boolean;
}

export async function getOnboardingStatus(): Promise<OnboardingResponse> {
  return apiGet<OnboardingResponse>('/onboarding/status');
}

export async function dismissOnboarding(): Promise<void> {
  return apiPost('/onboarding/dismiss');
}
